import type { ReactNode } from "react";
import { errorMessage } from "../lib/errors.js";

export function Loading({ label = "加载中…" }: { label?: string }) {
  return (
    <div className="center-pad" role="status" aria-label={label}>
      <div className="spinner" />
    </div>
  );
}

export function SkeletonList({ count = 3 }: { count?: number }) {
  return (
    <div className="stack" aria-hidden="true">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="skeleton skeleton-card" />
      ))}
    </div>
  );
}

/**
 * 查询失败。
 *
 * 显示后端给不出具体细节时也不要假装成功 —— 「读不到」与「空」是两回事，
 * 这一层是「读不到」的呈现。
 */
export function QueryError({
  error,
  onRetry,
  children,
}: {
  error: unknown;
  onRetry?: () => void;
  children?: ReactNode;
}) {
  return (
    <div className="empty">
      <div className="em-t">读不到</div>
      <div className="em-d">{errorMessage(error)}</div>
      {onRetry !== undefined && (
        <button type="button" className="btn btn-ghost btn-sm" onClick={onRetry}>
          重试
        </button>
      )}
      {children}
    </div>
  );
}
